import { controls } from "../../controls";

const rp910 = {
  label: "Purposewise Overdue",
  pageLabel: "Purposewise Overdue",
  starting: true,
  url: "rp910",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"from_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"to_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Purposewise Overdue Statement From - To",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Particulars",
        accessor: "particulars_code",
        width: 100,
        rwidth: 50
      },
      {
        Header: "Opening",
        accessor: "opening",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Sanction",
        accessor: "sanction",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Advance",
        accessor: "advance",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Recovery",
        accessor: "recovery",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Outstanding No. of Society",
        accessor: "outstanding_no_of_society",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Outstanding",
        accessor: "outstanding",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Overdue No. of Society",
        accessor: "overdue_no_of_society",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Overdue",
        accessor: "overdue",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "TRF Advance",
        accessor: "trf_advance",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "TRF Recovery",
        accessor: "trf_recovery",
        type:"currency",
        rwidth:"*"
      },
      {
        Header: "Future Recovery",
        accessor: "future_recovery",
        type:"currency",
        rwidth:"*"
      },
            
    ]
  }
};

export default rp910;